const PlentyCubes = () => {
  return (
    <svg width="86" height="66" viewBox="0 0 86 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_270_364)">
        <path d="M89 8.73297L73 17.4659L57 8.73297L73 0L89 8.73297Z" fill="url(#paint0_linear_270_364)"/>
        <path d="M89 26.1946L73 34.9276V17.4659L89 8.73297V26.1946Z" fill="url(#paint1_linear_270_364)"/>
        <path d="M73 34.9276L57 26.1946V8.73297L73 17.4659V34.9276Z" fill="url(#paint2_linear_270_364)"/>
        <path opacity="0.3" d="M73.2088 17.6681L73 34.9276V17.4659L73.2088 17.6681Z" fill="#3F75EA"/>
        <path opacity="0.3" d="M89 8.73297L73 17.4659L73.2088 17.6681L89 8.73297Z" fill="url(#paint3_linear_270_364)"/>
        <path opacity="0.3" d="M73 17.4659L57 8.73297L72.7017 17.6681L73 34.9276V17.4659Z" fill="#3F75EA"/>
        <path opacity="0.44" d="M57 8.73297L72.7017 17.6681L73 34.9276L57 26.1989V8.73297Z" fill="url(#paint4_linear_270_364)"/>
      </g>
      <g clipPath="url(#clip1_270_364)">
        <path d="M70 18.733L54 27.4659L38 18.733L54 10L70 18.733Z" fill="url(#paint5_linear_270_364)"/>
        <path d="M70 36.1946L54 44.9276V27.4659L70 18.733V36.1946Z" fill="url(#paint6_linear_270_364)"/>
        <path d="M54 44.9276L38 36.1946V18.733L54 27.4659V44.9276Z" fill="url(#paint7_linear_270_364)"/>
        <path d="M54.2088 27.6681L54 44.9276V27.4659L54.2088 27.6681Z" fill="#3F75EA"/>
        <path d="M70 18.733L54 27.4659L54.2088 27.6681L70 18.733Z" fill="url(#paint8_linear_270_364)"/>
        <path opacity="0.76" d="M54 27.4659L38 18.733L53.7017 27.6681L54 44.9276V27.4659Z" fill="#3F75EA"/>
        <path opacity="0.44" d="M38 18.733L53.7017 27.6681L54 44.9276L38 36.1989V18.733Z" fill="url(#paint9_linear_270_364)"/>
      </g>
      <path d="M51 28.733L35 37.4659L19 28.733L35 20L51 28.733Z" fill="url(#paint10_linear_270_364)"/>
      <path d="M51 46.1946L35 54.9276V37.4659L51 28.7329V46.1946Z" fill="url(#paint11_linear_270_364)"/>
      <path d="M35 54.9276L19 46.1946V28.7329L35 37.4659V54.9276Z" fill="url(#paint12_linear_270_364)"/>
      <path d="M35.2088 37.6681L35 54.9275V37.4659L35.2088 37.6681Z" fill="#04BB8B"/>
      <path d="M51 28.7329L35 37.4659L35.2088 37.6681L51 28.7329Z" fill="#04BB8B"/>
      <path opacity="0.75" d="M35 37.4659L19 28.7329L34.7017 37.6681L35 54.9276V37.4659Z" fill="#04BB8B"/>
      <g clipPath="url(#clip2_270_364)">
        <path d="M32 39.733L16 48.4659L0 39.733L16 31L32 39.733Z" fill="url(#paint13_linear_270_364)"/>
        <path d="M32 57.1946L16 65.9276V48.4659L32 39.733V57.1946Z" fill="url(#paint14_linear_270_364)"/>
        <path d="M16 65.9276L0 57.1946V39.733L16 48.4659V65.9276Z" fill="url(#paint15_linear_270_364)"/>
        <path d="M16.2088 48.6681L16 65.9276V48.4659L16.2088 48.6681Z" fill="#3F75EA"/>
        <path d="M32 39.733L16 48.4659L16.2088 48.6681L32 39.733Z" fill="url(#paint16_linear_270_364)"/>
        <path opacity="0.76" d="M16 48.4659L0 39.733L15.7017 48.6681L16 65.9276V48.4659Z" fill="#3F75EA"/>
        <path opacity="0.44" d="M0 39.733L15.7017 48.6681L16 65.9276L0 57.1989V39.733Z" fill="url(#paint17_linear_270_364)"/>
      </g>
      <defs>
        <linearGradient id="paint0_linear_270_364" x1="73.5" y1="17.5" x2="77.2837" y2="10.4463" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4D1E75" stopOpacity="0.87"/>
          <stop offset="1" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint1_linear_270_364" x1="73" y1="34.9998" x2="82.4972" y2="34.8367" gradientUnits="userSpaceOnUse">
          <stop offset="0.0156" stopColor="#5F328E" stopOpacity="0.44"/>
          <stop offset="0.9799" stopColor="#C597EB" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint2_linear_270_364" x1="70.0476" y1="17.2942" x2="43.6211" y2="40.5962" gradientUnits="userSpaceOnUse">
          <stop offset="0.0816" stopColor="#2E074F"/>
          <stop offset="0.2321" stopColor="#280648"/>
          <stop offset="0.4467" stopColor="#190536"/>
          <stop offset="0.661" stopColor="#03031C"/>
        </linearGradient>
        <linearGradient id="paint3_linear_270_364" x1="74.9525" y1="16.5292" x2="84.0433" y2="11.4001" gradientUnits="userSpaceOnUse">
          <stop offset="0.1456" stopColor="#3F75EA"/>
          <stop offset="0.9674" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint4_linear_270_364" x1="46" y1="2.05863" x2="81.467" y2="33.3363" gradientUnits="userSpaceOnUse">
          <stop stopColor="#AD3784"/>
          <stop offset="0.42" stopColor="#952E79" stopOpacity="0.7785"/>
          <stop offset="0.7271" stopColor="#56175D" stopOpacity="0.3122"/>
          <stop offset="0.9328" stopColor="#290749" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint5_linear_270_364" x1="38" y1="36.7969" x2="32.0773" y2="14.5083" gradientUnits="userSpaceOnUse">
          <stop offset="0.0156" stopColor="#1B0E72"/>
          <stop offset="0.9799" stopColor="#707DDF" stopOpacity="0.78"/>
        </linearGradient>
        <linearGradient id="paint6_linear_270_364" x1="71.0667" y1="35.156" x2="61.9177" y2="16.8703" gradientUnits="userSpaceOnUse">
          <stop offset="0.0156" stopColor="#1B0E72"/>
          <stop offset="0.9799" stopColor="#707DDF"/>
        </linearGradient>
        <linearGradient id="paint7_linear_270_364" x1="51.0476" y1="27.2942" x2="24.6211" y2="50.5962" gradientUnits="userSpaceOnUse">
          <stop offset="0.0816" stopColor="#2E074F"/>
          <stop offset="0.2321" stopColor="#280648"/>
          <stop offset="0.4467" stopColor="#190536"/>
          <stop offset="0.661" stopColor="#03031C"/>
        </linearGradient>
        <linearGradient id="paint8_linear_270_364" x1="55.9525" y1="26.5292" x2="70.2896" y2="18.6337" gradientUnits="userSpaceOnUse">
          <stop offset="0.1456" stopColor="#3F75EA"/>
          <stop offset="0.9674" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint9_linear_270_364" x1="23.6" y1="22.031" x2="56.3224" y2="29.3939" gradientUnits="userSpaceOnUse">
          <stop offset="0.03125" stopColor="#6E7DE3"/>
          <stop offset="1" stopColor="#0015A0"/>
        </linearGradient>
        <linearGradient id="paint10_linear_270_364" x1="12.607" y1="15.8193" x2="44.2631" y2="33.7287" gradientUnits="userSpaceOnUse">
          <stop offset="0.0575" stopColor="#2E3386"/>
          <stop offset="0.2313" stopColor="#2E3986"/>
          <stop offset="0.457" stopColor="#2C4986"/>
          <stop offset="0.7101" stopColor="#2A6485"/>
          <stop offset="0.9041" stopColor="#287D85"/>
        </linearGradient>
        <linearGradient id="paint11_linear_270_364" x1="31.5605" y1="59.7617" x2="52.7731" y2="27.1438" gradientUnits="userSpaceOnUse">
          <stop offset="0.2691" stopColor="#005B71"/>
          <stop offset="0.3379" stopColor="#006774"/>
          <stop offset="0.7146" stopColor="#03A385"/>
          <stop offset="0.8941" stopColor="#04BB8B"/>
        </linearGradient>
        <linearGradient id="paint12_linear_270_364" x1="19.5181" y1="46.325" x2="36.2282" y2="36.4783" gradientUnits="userSpaceOnUse">
          <stop stopColor="#015576"/>
          <stop offset="0.9573" stopColor="#113B62"/>
        </linearGradient>
        <linearGradient id="paint13_linear_270_364" x1="-3.96084" y1="28.2219" x2="27.6953" y2="46.1313" gradientUnits="userSpaceOnUse">
          <stop offset="0.323" stopColor="#2E074F"/>
          <stop offset="0.4405" stopColor="#330A55"/>
          <stop offset="0.593" stopColor="#421465"/>
          <stop offset="0.764" stopColor="#5B2480"/>
          <stop offset="0.8562" stopColor="#6B2F91"/>
        </linearGradient>
        <linearGradient id="paint14_linear_270_364" x1="17.2156" y1="63.4654" x2="33.5839" y2="38.2964" gradientUnits="userSpaceOnUse">
          <stop offset="0.0156" stopColor="#253E81"/>
          <stop offset="0.4345" stopColor="#6B2F91"/>
          <stop offset="0.5107" stopColor="#713090"/>
          <stop offset="0.6145" stopColor="#83328C"/>
          <stop offset="0.7342" stopColor="#9F3587"/>
          <stop offset="0.8648" stopColor="#C73A7F"/>
          <stop offset="0.9799" stopColor="#F03F77"/>
        </linearGradient>
        <linearGradient id="paint15_linear_270_364" x1="13.0476" y1="48.2942" x2="-13.3789" y2="71.5962" gradientUnits="userSpaceOnUse">
          <stop offset="0.0816" stopColor="#2E074F"/>
          <stop offset="0.2321" stopColor="#280648"/>
          <stop offset="0.4467" stopColor="#190536"/>
          <stop offset="0.661" stopColor="#03031C"/>
        </linearGradient>
        <linearGradient id="paint16_linear_270_364" x1="17.9525" y1="47.5292" x2="32.2896" y2="39.6337" gradientUnits="userSpaceOnUse">
          <stop offset="0.1456" stopColor="#3F75EA"/>
          <stop offset="0.9674" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint17_linear_270_364" x1="-6.02959" y1="62.3622" x2="14.7591" y2="48.5068" gradientUnits="userSpaceOnUse">
          <stop offset="0.2741" stopColor="#AD3784"/>
          <stop offset="0.42" stopColor="#952E79" stopOpacity="0.7785"/>
          <stop offset="0.7271" stopColor="#56175D" stopOpacity="0.3122"/>
          <stop offset="0.9328" stopColor="#290749" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="clip0_270_364">
          <rect width="32" height="35" fill="white" transform="translate(57)"/>
        </clipPath>
        <clipPath id="clip1_270_364">
          <rect width="32" height="35" fill="white" transform="translate(38 10)"/>
        </clipPath>
        <clipPath id="clip2_270_364">
          <rect width="32" height="35" fill="white" transform="translate(0 31)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default PlentyCubes;
